import { parseIsoDateString } from '../../../../../../../../../helpers/misc';
import Table from '../../../../../../../../../Template/layoutComponents/Table';
import TableTip from '../../../../../../../../../Template/layoutComponents/Table/components/tip';
import { getIssues } from '../../../../../../../../helpers/apiCalls';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import IssueDetailsModal from '../IssueDetailsModal/index.jsx';

import './style.css';
import { useState, useEffect } from 'react';
import useTemplateState from '../../../../../../../../../Template/atoms/variables.js';
import CommentModal from '../../../../../../../../components/CommentModal/index.jsx';
import { useParams } from 'react-router-dom';

const IssueTable = ({ issues, phaseTitle, forceReload, setForceReload }) => {
  const { t } = useTranslation();
  const { assetId, interconnectionId } = useParams();

  const {
    setModalOpen,
    setModalContent,
    setModalTitle,
    setModalStyle,
    setModalConfirm,
    setCleanOnCancel,
  } = useTemplateState();

  const [items, setItems] = useState([]);
  const [uniqueValues, setUniqueValues] = useState({});

  useEffect(() => {
    setItems(issues?.items?.map((item) => ({ ...item, action: 'placeholder' })));
    setUniqueValues(issues?.uniqueValues);
  }, [issues]);

  const handleOpenIssueDetails = (issue) => {
    setModalContent(
      <IssueDetailsModal
        givenIssue={issue}
        handleInsertComment={() => handleInsertComment(issue)}
        setForceReload={setForceReload}
      />,
    );
    setModalTitle(t('issue'));
    setModalStyle({
      padding: '2rem',
      gap: '1rem',
      maxHeight: '100%',
    });
    setModalConfirm(null);
    setCleanOnCancel(true);
    setModalOpen(true);
  };

  const handleInsertComment = (issue) => {
    setModalContent(<CommentModal modelName={'Issue'} related_to={issue._id} />);
    setModalTitle(t('comments'));
    setModalStyle({
      padding: '2rem',
      gap: '1rem',
      maxHeight: '100%',
    });
    setModalConfirm(null);
    setCleanOnCancel(true);
    setModalOpen(true);
  };

  return (
    <Table
      handleSelect={null}
      handleRowClick={null}
      apiCall={async (instance, query) => {
        const result = await getIssues(instance, {
          'subject._id': assetId ?? interconnectionId,
          stage: phaseTitle,
          'subject._type': assetId ? 'Asset' : 'Interconnection',
          ...query,
        });
        return {
          ...result,
          items: result.items?.map((item) => ({ ...item, action: 'placeholder' })),
        };
      }}
      items={items}
      startingTotalItems={issues?.totalItems}
      tableSettings={{
        columnsConfig: {
          task: {
            label: t('task'),
            customElement: (row) => {
              return row.task?.code;
            },
          },
          title: {
            label: t('name'),
          },
          createdAt: {
            label: t('created'),
            customElement: (row) => {
              return parseIsoDateString(typeof row === 'string' ? row : row?.createdAt);
            },
          },
          due_date: {
            label: t('due'),
            customElement: (row) => {
              return parseIsoDateString(typeof row === 'string' ? row : row?.due_date);
            },
          },
          assigned_to: {
            label: t('accountable'),
            customElement: (row) => {
              return <div> {typeof row === 'string' ? row : row?.assigned_to?.email} </div>;
            },
          },
          executor: {
            label: t('executor'),
            customElement: (row) => {
              return <div> {typeof row === 'string' ? row : row?.executor?.email} </div>;
            },
          },
          priority: {
            label: t('priority'),
            customElement: (row) => {
              return <TableTip children={typeof row === 'string' ? row : row.priority} />;
            },
          },
          status: {
            label: t('status'),
            customElement: (row) => {
              return <TableTip children={typeof row === 'string' ? row : row.status} />;
            },
          },
          action: {
            label: t('action'),
            customElement: (row) => {
              return (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                  <Button
                    size='large'
                    style={{
                      backgroundColor: 'white',
                      border: '1px solid #1777FF',
                      color: '#1777FF',
                    }}
                    onClick={() => handleInsertComment(row)}
                  >
                    {t('add_comment')}
                  </Button>
                  <Button
                    size='large'
                    style={{
                      backgroundColor: '#1777FF',
                      border: '#1777FF',
                      color: 'white',
                      opacity: row?.status?.toLowerCase() === 'approved' ? 0.5 : 1,
                    }}
                    disabled={row?.status?.toLowerCase() === 'approved'}
                    onClick={() => handleOpenIssueDetails(row)}
                  >
                    {t('view_details')}
                  </Button>
                </div>
              );
            },
          },
        },
        sortable: ['priority', 'createdAt', 'status', 'name', 'assigned_to', 'executor'],
        listFilter: ['status', 'priority'],
        searchFilter: ['title'],
        uniqueValues: uniqueValues,
      }}
      forceReload={forceReload}
      setForceReload={setForceReload}
    />
  );
};

export default IssueTable;
